// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"StartBench__wrapper--17C8Q","weekDropdown":"StartBench__weekDropdown--3D4Kp","label":"StartBench__label--FCrkX","positionsWrapper":"StartBench__positionsWrapper--2hc3c","collapsed":"StartBench__collapsed--1-mQY","tableWrapper":"StartBench__tableWrapper--1uoKy","togglesContainer":"StartBench__togglesContainer--24bhO"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/StartBench/StartBench.css
// module id = iA4q
// module chunks = 30